'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useRef } from 'react';

// Meta(Facebook) Pixel 베이스 태그. 설레임런 캠페인 광고 효율/전환 측정용.
// 나스미디어 트랙 가이드(2026-07) 기준 Pixel ID 는 NEXT_PUBLIC_META_PIXEL_ID 로 주입.
// 운영에만 값이 존재하며 local/미설정 환경에서는 렌더하지 않는다(캠페인 데이터 오염 방지).
const PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID || '';
const isLocal = process.env.NEXT_PUBLIC_MODE === 'local';

export function MetaPixel() {
  const pathname = usePathname();
  const isMounted = useRef(false);

  // 최초 로드 PageView 는 아래 인라인 스크립트가 처리하고,
  // 이후 SPA 라우트 변경 시에만 PageView 를 재발화한다(GA4 Analytics 컴포넌트와 동일 패턴).
  useEffect(() => {
    if (!PIXEL_ID || isLocal) return;
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    window.fbq?.('track', 'PageView');
  }, [pathname]);

  if (!PIXEL_ID || isLocal) return null;

  return (
    <>
      <Script
        id="meta-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`,
        }}
      />
      <noscript>
        {/* noscript 추적 비콘. next/image 는 <noscript> 에서 동작 불가하므로 raw <img> 필수. */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          alt=""
          src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
}
